import { createSvgIcon } from '@material-ui/core';

export const DataContractIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.5 44C7.97233 44 6.67367 43.4653 5.604 42.396C4.53467 41.3263 4 40.0277 4 38.5V32H10V4H40V38.5C40 40.0277 39.4653 41.3263 38.396 42.396C37.3263 43.4653 36.0277 44 34.5 44H9.5ZM34.497 40.6665C35.11 40.6665 35.6248 40.459 36.0415 40.044C36.4582 39.6287 36.6665 39.114 36.6665 38.5V7.3335H13.3335V32H32.3335V38.5C32.3335 39.114 32.5408 39.6287 32.9555 40.044C33.3702 40.459 33.884 40.6665 34.497 40.6665ZM16 16.6665V13.3335H34V16.6665H16ZM16 22.6665V19.3335H34V22.6665H16Z"
      fill="currentColor"
    />
  </svg>,
  'DataContractIcon',
);
